import React, {useContext, useEffect, useState} from 'react';
import {
	Avatar,
	Badge,
	Button,
	CardActionArea, CardActions,
	CardContent,
	CardHeader,
	Chip, Collapse,
	Divider, LinearProgress, Paper,
	Tooltip
} from "@mui/material";
import Typography from "@mui/material/Typography";
import {getDataLabel} from "../../../../utils/TableUtils";
import {calculateAge, capitalizeFirstLetter, capitalizeWords, diffDays} from "../../../../utils/GenericUtils";
import {amber, brown, green, grey, lightBlue, orange, purple, red} from "@mui/material/colors";
import moment from "moment";
import {calcScore, getLastMonitoraggioSintomi} from "../../focolai/detail/FocolaioCard";
import ErrorOutlineTwoToneIcon from "@mui/icons-material/ErrorOutlineTwoTone";
import CheckCircleOutlineTwoToneIcon from "@mui/icons-material/CheckCircleOutlineTwoTone";
import RadioButtonUncheckedTwoToneIcon from "@mui/icons-material/RadioButtonUncheckedTwoTone";
import multiavatar from "@multiavatar/multiavatar";
import SVG from "react-inlinesvg";
import SupervisedUserCircleTwoToneIcon from '@mui/icons-material/SupervisedUserCircleTwoTone';
import makeStyles from '@mui/styles/makeStyles';
import withStyles from '@mui/styles/withStyles';
import {setOpenSnackbar} from "../../../../services/AppServices";
import {useTheme} from "@mui/styles";
import {AppContext} from "../../../../App";
import AssignmentTurnedInTwoToneIcon from '@mui/icons-material/AssignmentTurnedInTwoTone';
import AccessTimeTwoToneIcon from '@mui/icons-material/AccessTimeTwoTone';
import LabelTwoToneIcon from '@mui/icons-material/LabelTwoTone';
import IconButton from "@mui/material/IconButton";
import clsx from "clsx";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Skeleton } from '@mui/material';
import {getQuarantenaHistoryArray} from "../../../../services/QuaranteneServices";
import {transformDTOtoReadableString} from "./HistoryCard";
import DeleteTwoToneIcon from '@mui/icons-material/DeleteTwoTone';
import axios from "axios";
import {UPDATE_QUARANTENA_URL} from "../../../../services/utils/ApiUrls";
import {getConfig} from "../../../../services/utils/ConfigUtils";

const useStyles = makeStyles((theme) => ({
	actions: {
		height: 14,
		justifyContent: "flex-end",
		alignItems: "flex-end"
	},
	expand: {
		transform: 'rotate(0deg)',
		marginTop: -10,
		transition: theme.transitions.create('transform', {
			duration: theme.transitions.duration.shortest,
		}),
	},
	expandOpen: {
		transform: 'rotate(180deg)',
	},
	customBadge: {
		"& .MuiBadge-anchorOriginBottomRightRectangular": {
			width: 82,
			transform: "scale(1) translate(40%, 60%)",
		}
	}
}));

const BorderLinearProgress = withStyles((theme) => ({
	root: {
		height: 10,
		borderRadius: 5,
	},
	colorPrimary: {
		backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 700],
	},
	bar: {
		borderRadius: 5,
		backgroundColor: '#1a90ff',
	},
}))(LinearProgress);

const BorderLinearProgressError = withStyles((theme) => ({
	root: {
		height: 10,
		borderRadius: 5,
	},
	colorPrimary: {
		backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 700],
	},
	bar: {
		borderRadius: 5,
		backgroundColor: '#fa2b3c',
	},
}))(LinearProgress);

const QuarantenaCard = ({
	                        quarantena, onclickQuarantena, setValue = () => {
	}
                        }) => {
	
	const classes = useStyles();
	const theme = useTheme();
	const appContext = useContext(AppContext);
	const [expanded, setExpanded] = React.useState(false);
	const [storico, setStorico] = useState([]);
	const [loading, setLoading] = useState(false);
	const [loadingDelete, setLoadingDelete] = useState(false);
	
	
	const handleExpandClick = (event) => {
		event.preventDefault();
		event.stopPropagation();
		setExpanded(!expanded);
	};
	
	const deleteQuarantena = (event, quarantena) => {
		event.preventDefault();
		event.stopPropagation();
		setLoadingDelete(true);
		axios
			.post(UPDATE_QUARANTENA_URL + quarantena.id, {
				...quarantena,
				deleted: "true",
			}, getConfig())
			.then(() => {
				alert("Quarantena eliminata con successo!");
				setLoadingDelete(false);
				window.location.reload();
			})
			.catch(() => {
				alert("Ops, c'è stato un problema nell'eliminazione...");
				setLoadingDelete(false);
			})
	}
	
	useEffect(() => {
		if (expanded) {
			setLoading(true);
			getQuarantenaHistoryArray(quarantena.id, (s) => setStorico(s))
				.then(() => setLoading(false))
		}
	}, [expanded, quarantena])
	
	return (
        <React.Fragment>
            <CardActionArea onClick={() => onclickQuarantena(quarantena)}>
				<CardHeader
					style={{paddingBottom: 2}}
					avatar={
						<Badge
							style={{marginRight: 20}}
							className={classes.customBadge}
							color={"error"}
							badgeContent={quarantena.stato}
							anchorOrigin={{
								vertical: 'bottom',
								horizontal: 'right',
							}}
						>
							<Avatar>
								<SVG src={multiavatar(quarantena?.soggetto?.codF)}/>
							</Avatar>
						</Badge>
					}
					title={
						<div style={{display: "flex", alignItems: "center", width: "100%"}}>
							<Typography variant={"subtitle1"}
							            style={{flexGrow: 1}}><b>{(quarantena.tipo === "Quarantena" ? "Autosorveglianza" : quarantena.tipo) + " - " + quarantena.soggetto.codF + " - " + capitalizeWords(quarantena.soggetto.nome) + " " + capitalizeWords(quarantena.soggetto.cognome)}</b></Typography>
							<div>
								<Typography variant={"body2"} color={"textSecondary"}>
									{moment(quarantena.dataInizio).format("DD/MM/YY") + " - " + moment(quarantena.dataFine).format("DD/MM/YY") + "  (" + diffDays(new Date(quarantena.dataInizio), new Date()) + "/" + (diffDays(new Date(quarantena.dataInizio), new Date(quarantena.dataFine)) + 1) + ")"}
								</Typography>
								{
									new Date(quarantena.dataFine) < new Date() ?
										<BorderLinearProgressError variant={"determinate"} value={
											100 * diffDays(new Date(quarantena.dataInizio), new Date()) / diffDays(new Date(quarantena.dataInizio), (new Date(quarantena.dataFine)))
										}/> :
										<BorderLinearProgress variant={"determinate"} value={
											100 * diffDays(new Date(quarantena.dataInizio), new Date()) / diffDays(new Date(quarantena.dataInizio), new Date(quarantena.dataFine))
										}/>
								}
								{/*
								 diffDays(new Date(quarantena.dataInizio), new Date()) : X =  diffDays(new Date(quarantena.dataInizio), new Date(quarantena.dataFine)) : 100
								 100 *  diffDays(new Date(quarantena.dataInizio), new Date()) / diffDays(new Date(quarantena.dataInizio), new Date(quarantena.dataFine))
								 */}
							</div>
							<Chip icon={calcScore(quarantena.monitoraggi, quarantena.tipo, quarantena.score) >= 3 ?
								<ErrorOutlineTwoToneIcon style={{color: "#FFF"}}/> :
								calcScore(quarantena.monitoraggi, quarantena.tipo, quarantena.score) <= 1 ?
									<CheckCircleOutlineTwoToneIcon
										style={{color: calcScore(quarantena.monitoraggi, quarantena.tipo, quarantena.score) === 1 ? "#000" : "#FFF"}}/> :
									<RadioButtonUncheckedTwoToneIcon
										style={{color: calcScore(quarantena.monitoraggi, quarantena.tipo, quarantena.score) === 1 ? "#000" : "#FFF"}}/>}
							      label={"SCORE " + calcScore(quarantena.monitoraggi, quarantena.tipo, quarantena.score)}
							      style={{
								      marginRight: 10,
								      marginLeft: 10,
								      padding: 4,
								      fontWeight: "bold",
								      color: calcScore(quarantena.monitoraggi, quarantena.tipo, quarantena.score) === 1 ? "#000" : "#FFF",
								      backgroundColor: getScoreColor(quarantena.tipo, quarantena.monitoraggi, quarantena.score)
							      }}/>
						</div>}
					subheader={
						quarantena.active ?
							<Typography variant={"body2"} color={"error"}>
								In gestione da parte di <b>{quarantena.lastModify}</b>
							</Typography> :
							<Typography variant={"body2"} color={"textSecondary"}>
								Ultima modifica: <b>{getDataLabel(quarantena.ultimaModifica)}</b> da parte
								di <b>{quarantena.lastModify}</b>
							</Typography>}
				/>
				<CardContent style={{paddingTop: 8}}>
					<div style={{display: "flex"}}>
						<Tooltip title={"Clicca per copiare"}>
							<Button variant={"text"}
							        style={{padding: 2, color: theme.palette.text.secondary, textTransform: "none"}}
							        component={"div"}
							        onClick={(event) => {
								        event.stopPropagation();
								        navigator?.clipboard?.writeText(quarantena.id).then(() => {
									        setOpenSnackbar("info", "ID copiato negli appunti", appContext.dispatch);
								        })
							        }}>
								<b>{"ID: " + quarantena.id}</b>
							</Button>
						</Tooltip>
						<Divider orientation={"vertical"}
						         style={{height: 16, marginLeft: 10, marginRight: 10, alignSelf: "center"}}/>
						<Tooltip title={"Clicca per copiare"}>
							<Button variant={"text"}
							        style={{padding: 2, color: theme.palette.text.secondary, textTransform: "none"}}
							        component={"div"}
							        onClick={(event) => {
								        event.stopPropagation();
								        navigator?.clipboard?.writeText(quarantena?.soggetto?.codF).then(() => {
									        setOpenSnackbar("info", "Documento copiato negli appunti", appContext.dispatch);
								        })
							        }}>
								<b>{quarantena.soggetto?.codF + ", " + capitalizeWords(quarantena.soggetto?.nome) + " " + capitalizeWords(quarantena.soggetto?.cognome) + (quarantena.soggetto?.dataNascita ? (", " + calculateAge(quarantena.soggetto.dataNascita) + " anni") : "")}</b>
							</Button>
						</Tooltip>
					</div>
					<Typography variant={"body2"} color={"textSecondary"} noWrap={false}>
						{quarantena.note?.replaceAll(/#(\S*)/g, "")}
					</Typography>
					<div>
						{
							quarantena.deleted === "true" &&
							<Chip label={"CANCELLATA"} style={{
								marginRight: 8,
								marginTop: 8,
								backgroundColor: red[500],
								color: "#FFF",
							}}/>
						}
						{
							quarantena.groupId &&
							<Chip label={quarantena.groupId} style={{
								marginRight: 8,
								marginTop: 8,
							}}/>
						}
						{
							quarantena.compilatoMonitoraggioGiornaliero &&
							<Chip
								label={"Compilato giornaliero"}
								icon={<AssignmentTurnedInTwoToneIcon style={{color: "#FFF", fontSize: 18}}/>}
								style={{
									marginRight: 8,
									marginTop: 8,
									backgroundColor: green[500],
									color: "#FFF"
								}}
							/>
						}
						{
							quarantena.ultimoMonitoraggio &&
							<Chip
								label={"Ultimo monitoraggio: " + getDataLabel(new Date(quarantena.ultimoMonitoraggio))}
								icon={<AccessTimeTwoToneIcon style={{color: "#FFF", fontSize: 18}}/>}
								style={{
									marginRight: 8,
									marginTop: 8,
									backgroundColor: orange[500],
									color: "#FFF"
								}}
							/>
						}
						{
							getLastMonitoraggioSintomi(quarantena.monitoraggi).map(sintomo => {
								return (
									<Chip
										key={sintomo}
										label={capitalizeFirstLetter(sintomo)}
										avatar={<Avatar><b>#</b></Avatar>}
										color={"secondary"}
										style={{
											marginRight: 8,
											marginTop: 8,
										}}/>
								)
							})
						}
						{
							quarantena.note?.includes("#COMUNITÀ") &&
							<Chip label={"COMUNITÀ"}
							      clickable
							      onClick={(event) => {
								      event.stopPropagation();
								      setValue("#COMUNITÀ");
							      }
							      }
							      avatar={<Avatar style={{backgroundColor: purple[700]}}><SupervisedUserCircleTwoToneIcon
								      style={{color: "#FFF", fontSize: 18}}/></Avatar>} style={{
								marginRight: 8,
								marginTop: 8,
								backgroundColor: purple[500],
								color: "#FFF"
							}}/>
						}
						{
							quarantena.note?.match(/#(\S*)/g)?.filter(tag => tag !== "#COMUNITÀ")?.map((item, index) => {
								return (
									<Tooltip key={item + index} title={"Clicca per cercare tramite #hastag."}>
										<Chip
											clickable
											onClick={(event) => {
												event.stopPropagation();
												setValue(item.replace(" ", ""));
											}
											}
											label={capitalizeFirstLetter(item.replaceAll("_", " "))}
											avatar={<Avatar><b>#</b></Avatar>}
											color={"secondary"}
											style={{
												marginRight: 8,
												marginTop: 8,
											}}/>
									</Tooltip>
								)
							})
						}
						{
							quarantena.tag &&
							<Chip
								label={quarantena.tag}
								icon={<LabelTwoToneIcon style={{fontSize: 22, color: "#FFF"}}/>}
								color={"default"}
								style={{
									marginRight: 8,
									marginTop: 8,
									backgroundColor: purple[600],
									color: "#FFF"
								}}/>
						}
						{
							quarantena.protocollo !== null && quarantena.protocollo === "Accetta il tampone" &&
							<Chip
								label={quarantena.protocollo ? "Accetta il tampone" : "Non accetta il tampone"}
								icon={<LabelTwoToneIcon style={{fontSize: 22, color: "#FFF"}}/>}
								color={"default"}
								style={{
									marginRight: 8,
									marginTop: 8,
									backgroundColor: brown[600],
									color: "#FFF"
								}}/>
						}
					</div>
				
				
				</CardContent>
			</CardActionArea>
            <CardActions className={classes.actions} disableSpacing>
				<Tooltip title={"Elimina quarantena"}>
					<IconButton
						size={"small"}
						disabled={loadingDelete}
						className={classes.expand}
						onClick={(e) => deleteQuarantena(e, quarantena)}
						aria-expanded={expanded}
						aria-label="show more"
					>
						<DeleteTwoToneIcon/>
					</IconButton>
				</Tooltip>
				<Tooltip title={"Mostra storico quarantena"}>
					<IconButton
						size={"small"}
						className={clsx(classes.expand, {
							[classes.expandOpen]: expanded,
						})}
						onClick={handleExpandClick}
						aria-expanded={expanded}
						aria-label="show more"
					>
						<ExpandMoreIcon/>
					</IconButton>
				</Tooltip>
			</CardActions>
            <Collapse in={expanded} timeout="auto" unmountOnExit>
				<CardContent>
					{
						loading ? <Skeleton height={300}/> :
							storico
								.filter(stoElem => !stoElem.lastModify.includes("AUTODUMP"))
								.sort((a, b) => new Date(b.dataModifica) - new Date(a.dataModifica))
								.map((item, index) => {
									return (
										<Paper elevation={0} key={index} id={"paper-storico" + index}
										       style={{
											       backgroundColor: theme.palette.mode === "light" ? lightBlue[50] : lightBlue[800],
											       borderRadius: 24,
											       padding: 16,
											       marginRight: 100,
											       marginTop: 16
										       }}>
											<Typography variant={"subtitle2"} color={"textSecondary"}>
												<b>{item.lastModify}</b> ha scritto in
												data: {moment(item.dataModifica).format("DD/MM/YYYY - HH:mm")}
											</Typography>
											<Typography variant={"subtitle1"}>
												{
													item.note?.includes("DTO") ? transformDTOtoReadableString(item.note) : item.note
												}
											</Typography>
										</Paper>
									)
								})
					}
				</CardContent>
			</Collapse>
        </React.Fragment>
    );
};

export function getScoreColor(tipo, monitoraggi, score, calc = true) {
	let calculedScore;
	if (calc) {
		calculedScore = calcScore(monitoraggi, tipo, score);
	} else {
		calculedScore = score
	}
	if (tipo === "Isolamento") {
		switch (calculedScore) {
			default:
				return grey[100];
			case 2:
				return green[500];
			case 3:
				return amber[500];
			case 4:
				return red[500];
		}
	} else {
		switch (calculedScore) {
			default:
				return green[500];
			case 1:
				return amber[500];
			case 2:
				return orange[500];
			case 3:
				return red[500];
			case 4:
				return purple[500];
		}
	}
}

export default React.memo(QuarantenaCard);
